import { TableContainer } from "../../../DemandaCriada/styles";
import { Parte } from "../../../DemandaCriada/types";
import styled from "styled-components";

const ParteHeader = styled.div<{ tipo: 'adicionada' | 'removida' }>`
    background-color: rgba(0, 0, 0, 0.03);
    padding: 6px 8px;
    font-size: 9px;
    font-weight: 500;
    text-transform: uppercase;
    color: var(--c64748b);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 6px;
    
    .tipo-alteracao {
        font-weight: 600;
        color: ${({ tipo }) => {
            switch (tipo) {
                case 'adicionada':
                    return '#2E86DE';
                case 'removida':
                    return '#E5293F';
                default:
                    return '#64748B';
            }
        }};
    }
`;

interface CardParteRepresentadaEditadaProps {
    parte: Parte;
    tipoAlteracao: 'adicionada' | 'removida';
}

export default function CardParteRepresentadaEditada({ parte, tipoAlteracao }: CardParteRepresentadaEditadaProps) {
    const getTipoLabel = (tipo: 'adicionada' | 'removida'): string => {
        switch (tipo) {
            case 'adicionada':
                return 'ADICIONADA';
            case 'removida':
                return 'REMOVIDA';
            default:
                return '';
        }
    };

    return (
        <TableContainer>
            <ParteHeader tipo={tipoAlteracao}>
                <span>PARTE REPRESENTADA</span>
                <span>•</span>
                <span className="tipo-alteracao">{getTipoLabel(tipoAlteracao)}</span>
            </ParteHeader>
            <table className="data-table">
                <thead>
                    <tr>
                        <th className="field-col">Campo</th>
                        <th className="value-col">Valor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="field-cell">Nome</td>
                        <td className="value-cell">{parte.nome}</td>
                    </tr>
                </tbody>
            </table>
        </TableContainer>
    );
}

